export default __webpack_public_path__ + "static/media/over-size-weight.6ec90ce9.svg";